import * as yup from 'yup';
import { GlassWasherStatusType } from '../types';

export const createGlassWasherDialogSchema = yup.object().shape({
  venueId: yup.string().nullable().default(null).label('Venue ID'),
  barId: yup.string().nullable().default(null).label('Bar ID'),
  position: yup.number().required().label('Position'),
  location: yup.string().nullable().default(null).label('Location'),
  status: yup.mixed<GlassWasherStatusType>().oneOf(Object.values(GlassWasherStatusType)).required().label('Status'),
  description: yup.string().nullable().default(null).label('Description'),
  detergentPerLevel: yup.number().nullable().default(null).label('Detergent par level'),
  rinsePerLevel: yup.number().nullable().default(null).label('Rinse par level'),
  shouldShift: yup.boolean().nullable().default(null).label('Should shift')
});

export const updateGlassWasherDialogSchema = yup.object().shape({
  glassWasherId: yup.string().nullable().default(null).label('Glass washer ID'),
  venueId: yup.string().nullable().default(null).label('Venue ID'),
  barId: yup.string().nullable().default(null).label('Bar ID'),
  position: yup.number().required().label('Position'),
  location: yup.string().nullable().default(null).label('Location'),
  status: yup.mixed<GlassWasherStatusType>().oneOf(Object.values(GlassWasherStatusType)).required().label('Status'),
  description: yup.string().nullable().default(null).label('Description'),
  detergentPerLevel: yup.number().nullable().default(null).label('Detergent par level'),
  rinsePerLevel: yup.number().nullable().default(null).label('Rinse par level'),
  shouldShift: yup.boolean().nullable().default(null).label('Should shift')
});
